import script from "./ViewOrgTorneo.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewOrgTorneo.vue?vue&type=script&setup=true&lang=js"

import "./ViewOrgTorneo.vue?vue&type=style&index=0&id=b7cae630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7cae630"]])

export default __exports__